const Footer = () => {
  return (
    <footer className="bg-[#F4F1EA] border-t border-[#1F1F1F]/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 mb-16">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <img 
                src="/image-3.svg" 
                alt="Logo" 
                className="w-10 h-10"
                style={{ filter: 'brightness(0)' }}
              />
              <span className="text-2xl font-bold tracking-tight" style={{ fontFamily: 'Montserrat, sans-serif' }}>Trippy</span>
            </div>
            <p className="font-typewriter text-xs max-w-xs opacity-60">
              AI-платформа для создания и тестирования карточек товаров для маркетплейсов. Скорость, система и интеллект.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-12 lg:gap-24">
            <div>
              <h4 className="font-serif-display italic text-xl mb-4 text-[#b7eb6f]">Продукт</h4>
              <ul className="space-y-3 font-typewriter text-xs uppercase tracking-widest opacity-80">
                <li><a href="#" className="hover:text-[#b7eb6f]">Анализ</a></li>
                <li><a href="#" className="hover:text-[#b7eb6f]">Тестирование</a></li>
                <li><a href="#" className="hover:text-[#b7eb6f]">Стили</a></li>
                <li><a href="#" className="hover:text-[#b7eb6f]">Возможности</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-serif-display italic text-xl mb-4 text-[#b7eb6f]">Юридическое</h4>
              <ul className="space-y-3 font-typewriter text-xs uppercase tracking-widest opacity-80">
                <li><a href="#" className="hover:text-[#b7eb6f]">Политика</a></li>
                <li><a href="#" className="hover:text-[#b7eb6f]">Условия</a></li>
                <li><a href="#" className="hover:text-[#b7eb6f]">Оферта</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-[#1F1F1F]/5 font-typewriter text-[10px] uppercase tracking-widest opacity-40">
          <p>© 2024 Tripi. Все права защищены.</p>
          <p>Сделано с интеллектом для селлеров</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
